import { render } from "./WCCouponScissorsIcon.vue?vue&type=template&id=700530c6&scoped=true"
const script = {}

import "./WCCouponScissorsIcon.vue?vue&type=style&index=0&id=700530c6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700530c6"]])

export default __exports__